import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { Dropdown, Menu } from "antd";
import Layout from "../../components/Layout";
import { DotMenuIcon, } from "../../assets/Icons";

import { capitalizeFirstLetter, getDateString } from "../../utils/functions";
import Modal from "../../components/Modal";
import { getRequest, postRequest } from "../../Api";

import DataTable from "../../components/DataTable";
import { useSelector } from "react-redux";
import Loader from "../../components/Loader";
import { useNavigate } from "react-router-dom";
import RejectedReasonModel from "../../components/RejectedReasonModel";

const BalanceRequests = () => {

    const words = useSelector((state) => state.authReducer.words);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [balanceRequests, setBalanceRequests] = useState([]);
    const [balanceRequestId, setBalanceRequestId] = useState('');
    const [rejectedBalanceRequestModel, setRejectedBalanceRequestModel] = useState(false);


    const columns = [
        {
            title: words["id"],
            dataIndex: "id",
            key: "title",
        },
        {
            title: words["Amount"],
            dataIndex: "amount_requested",
            key: "amount_requested",
            render: (_, record) => (
                <div
                    className="px-2 py-2 text-left text-sm text-black font-medium"
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                    }}
                >
                    {words["OMR"]} {record.amount_requested}
                </div>
            )
        },
        {
            title: words["Name"],
            dataIndex: "storename",
            key: "store.name",
            render: (_, record) => (
                <div
                    className="px-2 py-2 text-left text-sm text-black font-medium"
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                    }}
                >
                    {capitalizeFirstLetter(record.store?.store_name)}
                </div>
                // user-details/7
            )
        },


        {
            title: words["Date"],
            dataIndex: "date",
            key: "date",
            render: (_, record) => (
                <div
                    className="px-2 py-2 text-left text-sm text-black font-medium"
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                    }}
                >
                    {getDateString(record.created_at)}
                </div>
            ),
        },



        {
            title: words["Action"],
            key: "action",
            render: (_, record) => (
                <Dropdown
                    overlay={
                        <Menu
                            onClick={({ key }) => {
                                if (key == "view") {
                                    navigate("/dashboard/user-details/" + record.store.id);
                                    return;
                                }

                                setBalanceRequestId(record.id);
                                if (key == 'add') {
                                    return handleBalanceRequest('added', null, record.id)
                                }
                                if (key == 'reject') {
                                    setRejectedBalanceRequestModel(true);
                                    return;
                                }
                            }}
                        >
                            <>
                                <Menu.Item key="add">{words["Add"]}</Menu.Item>
                                <Menu.Item key="reject">{words["Reject"]}</Menu.Item>
                                <Menu.Item key="view">{words["View store"]}</Menu.Item>
                            </>
                        </Menu>
                    }
                    trigger={["click"]}
                >
                    <div className="flex items-center justify-center cursor-pointer text-[#0025F2]">
                        <DotMenuIcon />
                    </div>
                </Dropdown>
            ),
        },
    ];


    const handleBalanceRequest = async (status, reason, id) => {

        setRejectedBalanceRequestModel(false);
        const onSuccess = () => {
            if (status == 'added') toast.success('Balance added successfully');
            if (status == 'rejected') toast.success('Balance request rejected successfully');
            getBalanceRequests();
        }

        const onError = (res) => {
            console.log('err', res)
            setLoading(false);
            toast.error(res?.error)
        }

        const body = {
            status,
            id: id
        }
        if (status == 'rejected') body.rejected_reason = reason;

        setLoading(true);
        await postRequest(body, '/api/admin/balance-request', true, onSuccess, onError)
    }



    const getBalanceRequests = async () => {
        const onSuccess = (res) => {
            setBalanceRequests(res.data);
            setLoading(false);
        };

        const onError = (err) => {
            setLoading(false);
            toast.error(err?.error);
        }

        setLoading(true);
        await getRequest("", '/api/admin/get-balance-request', true, onSuccess, onError);
    };



    useEffect(() => {
        getBalanceRequests();
    }, []);


    return (
        <>
            {loading && <Loader />}
            <Layout pageTitle={words["Banner"]}>
                <div className="banner-page min-h-screen flex">
                    <div className="wrap wrapWidth flex flex-col">
                        <div className="flex flex-col gap-5 mt-6">


                            <div>
                                <DataTable
                                    searchContainerStyle={{ width: "40%" }}
                                    data={balanceRequests}
                                    columns={columns}
                                />
                            </div>
                        </div>
                    </div>

                </div>

                <Modal open={rejectedBalanceRequestModel} setOpen={setRejectedBalanceRequestModel}>
                    <RejectedReasonModel
                        openModal={rejectedBalanceRequestModel}
                        setOpenModal={setRejectedBalanceRequestModel}
                        onSubmit={(reason) => handleBalanceRequest('rejected', reason, balanceRequestId)}
                    />
                </Modal>


            </Layout>
        </>
    );
};

export default BalanceRequests;
